import groupBy from 'lodash/groupBy'
import { formatDateToGroupBy, sanitizeHealthProceduresType } from './helpers'
import { IHealthProcedures } from '~/interfaces'

interface GroupByStartDateRequired {
  startDate: string
}

interface GroupByPeriodReturn<T> {
  [date: string]: T[]
}

interface GroupByTypeReturn {
  [date: string]: IHealthProcedures[]
}

export const groupByYear = <T extends GroupByStartDateRequired>(healthProcedures: T[]): GroupByPeriodReturn<T> => {
  return groupBy(healthProcedures, healthProcedure => {
    const initialDate = new Date(healthProcedure.startDate)
    const year = initialDate.getFullYear()
    return year.toString()
  })
}

export const groupByMonth = <T extends GroupByStartDateRequired>(healthProcedures: T[]): GroupByPeriodReturn<T> => {
  return groupBy(healthProcedures, healthProcedure => {
    const initialDate = new Date(healthProcedure.startDate)
    const monthDate = new Date(initialDate.getFullYear(), initialDate.getMonth(), 1)
    return formatDateToGroupBy(monthDate)
  })
}

export const groupByStartDay = <T extends GroupByStartDateRequired>(healthProcedures: T[]): GroupByPeriodReturn<T> => {
  return groupBy(healthProcedures, healthProcedure => {
    const initialDate = new Date(healthProcedure.startDate)
    const resetHoursInDay = new Date(initialDate.getFullYear(), initialDate.getMonth(), initialDate.getDate())
    return formatDateToGroupBy(resetHoursInDay)
  })
}

export const groupByHealthProcedureType = (healthProcedures: IHealthProcedures[]): GroupByTypeReturn => {
  return groupBy(healthProcedures, (healthProcedure: IHealthProcedures) => {
    return sanitizeHealthProceduresType(healthProcedure)
  })
}
